const GIFT_HANDLE = "🎁-free-rakhi-with-every-order-🎁";
const MINIMUM_AMOUNT = 99900; // ₹999

async function getGiftVariantId() {
    const product = await fetch(`/products/${GIFT_HANDLE}.js`).then(r => r.json());
    return product.variants[0].id;
}

async function checkGift() {

    const GIFT_VARIANT = await getGiftVariantId();

    const cart = await fetch('/cart.js').then(r => r.json());

    let subtotal = cart.items_subtotal_price;

    const gift = cart.items.find(item => item.variant_id == GIFT_VARIANT);

    // Don't count the gift itself
    if (gift) {
        subtotal -= gift.final_line_price;
    }

    if (subtotal >= MINIMUM_AMOUNT) {

        if (!gift) {

            await fetch('/cart/add.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    items: [{
                        id: GIFT_VARIANT,
                        quantity: 1
                    }]
                })
            });

            location.reload();
        }

    } else {

        if (gift) {

            await fetch('/cart/change.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    id: gift.key,
                    quantity: 0
                })
            });

            location.reload();
        }

    }

}

document.addEventListener("DOMContentLoaded", checkGift);